<script setup>
import { breakpointsTailwind, useBreakpoints } from '@vueuse/core'
import { useAppStore } from '@stores/App';

const app = useAppStore();
const breakpoints = app.getBreakpoints();

const smWidth = breakpointsTailwind.sm

const isGreaterThanBreakpoint = breakpoints.greaterOrEqual(() => 'sm')

const current = breakpoints.current()
const active = breakpoints.active()
const xs = breakpoints.smaller('sm')
const xse = breakpoints.smallerOrEqual('sm')
const sm = breakpoints.between('sm', 'md')
const md = breakpoints.between('md', 'lg')
</script>
<template>
    <div class="font-mono">
        <div> Current breakpoints: {{ current }} </div>
        <div> Active breakpoint: {{ active }} </div>
        <div> xs(&lt;{{ smWidth }}px): {{ xs ? 'J' : 'N' }}</div>
        <div> xs(&lt;={{ smWidth }}px): {{ xse ? 'J' : 'N' }}</div>
        <div> sm: {{ sm ? 'J' : 'N' }}</div>
        <div> md: {{ md ? 'J' : 'N' }}</div>
        <div>greaterThanBreakPoint: {{ isGreaterThanBreakpoint ? 'J' : 'N' }}</div>
    </div>
</template>
